import { render } from "./PageLoad.vue?vue&type=template&id=147a00e2"
const script = {}

import "./PageLoad.vue?vue&type=style&index=0&id=147a00e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__